export default __webpack_public_path__ + "static/media/team5.c76a1324.png";